import getStore from '@ve/services/getStore/getStore';
import namesRepository from './config';
import OperatorRepository from './operator/OperatorRepository';

export default function initializeRepositories(): void {
    const store = getStore();
    store.registerModule(namesRepository.operatorRepositoryName, OperatorRepository);
}